<div class="flex select-none flex-col overflow-hidden rounded-lg hover:cursor-pointer">
	<button (click)="$expanded.set(!$expanded())">
		<ng-container *ngTemplateOutlet="$headerTemplate(); context: { $implicit: $expanded() }" />
	</button>

	@if ($expanded()) {
		<div
			@expandCollapse
			class="overflow-visible"
		>
			<ng-container *ngTemplateOutlet="$contentTemplate()" />
		</div>
	}
</div>
